module.exports = __webpack_public_path__ + "static/CORPORATE_SITE__HEADER_MB_HP1-727b6c6aed2e47ccb8b256033771ff82.gif";